import { render, staticRenderFns } from "./BpmnJS.vue?vue&type=template&id=32ecc4b1&scoped=true&"
import script from "./BpmnJS.vue?vue&type=script&lang=js&"
export * from "./BpmnJS.vue?vue&type=script&lang=js&"
import style0 from "./BpmnJS.vue?vue&type=style&index=0&id=32ecc4b1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ecc4b1",
  null
  
)

export default component.exports